import { Icon, Heading } from "@amzn/storm-ui";
import * as React from "react";

export const LoadingSpinner: React.FunctionComponent<{ prompt?: string }> = (
    props,
) => {
    return (
        <div
            data-testid="loading-spinner"
            role="alert"
            aria-live="assertive"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                margin: 75,
            }}
        >
            <Icon type="spinner" size="3x" style={{ opacity: "0.5" }} />
            <Heading
                renderAs="h3"
                color="secondary"
                style={{ marginTop: "1rem" }}
            >
                {props.prompt ?? "Loading"}
            </Heading>
        </div>
    );
};
